<template>

	<div class="panel panel-clinic">

		<div class="panel-heading collapsed" href="#form_supplementary_external" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Tilläggsinformation företagsmassör</h2>

		</div>

		<div id="form_supplementary_external" class="panel-collapse collapse">

			<div class="panel-body">

				<div class="form-horizontal">

					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_days_available_external"
						layout="textInput"
						title="Tillgänglighet företagsuppdrag"
						comment="Hur många dagar i veckan/månaden skulle du kunna vara tillgänglig för företagsuppdrag?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_weekdays_available_external"
						layout="textInput"
						title="Tillgänglighet, veckodagar"
						comment="Är det några speciella dagar du är, eller inte är, tillgänglig?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:show-comment="true"
						type="checkbox_has_bench"
						layout="checkBox"
						title="Egen bänk"
						comment="Har du egen bärbar bänk att ta med vid behov?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:show-comment="true"
						type="checkbox_has_car"
						layout="checkBox"
						title="Bil"
						comment="Har du tillgång till bil vid behov?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_area"
						layout="textBox"
						title="Arbetsområde"
						comment="Vilket geografiskt område är av intresse gällande företagsuppdrag?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
						:showComment="true"
						type="select_insurance_external"
						layout="selectMenu"
						title="Försäkring"
						comment="Har du gällande patient- och ansvarsförsäkring?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
						:showComment="true"
						type="text_ftax_external"
						layout="selectMenu"
						title="F-skatt / AB"
						comment="Har du registrerad f-skatt / AB?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
						:showComment="true"
						type="text_invoice_company_external"
						layout="selectMenu"
						title="Externt faktureringsbolag"
						comment="Kommer du att använda externt faktureringsbolag? Vid användandet av externt faktureringsbolag krävs varken f-skatt eller försäkring. Hur försäkring gäller kan dock behöva kontrolleras. Detta är massörens ansvar.">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						:showComment="true"
						type="checkbox_compensation_discussed_external"
						layout="checkBox"
						title="Diskuterad ersättningsnivå företagsuppdrag"
						comment="Informerad om gällande ersättningsnivå på företagsuppdrag?">
					</row-meta>
					<row-meta
						:clinic-id="clinic.id"
						:row-meta="meta"
						type="text_references_trial_external"
						layout="textBox"
						title="Referenser / provmassage"
						comment="Har du möjlighet att lämna referenser / alternativt genomföra provmassage?<br>I Göteborg, Malmö och Stockhom använder vi provmassage. Övriga orter lämnas referenser.">
					</row-meta>
					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="textarea_supplementary_external_extra_info"
							layout="textBox"
							title="Extra anteckningsruta, tilläggsfrågor mottagningsmassör"
							comment="Något annat du vill anteckna?">
					</row-meta>

				</div>

			</div>

		</div>

	</div>

</template>


<script>

	import mixin from './mixin'

    export default {

    	mixins: [mixin],

	    data() {

      		return {



      		}

	    },

	}

</script>
